import LumosApolloClient from '@lumoslabs/lumos_apollo_client';
import { fetch as fetchPolyfill } from 'whatwg-fetch';

const uri = `${process.env.GATSBY_LUMOSITY_HOST}/graph_api/v3`;
export default new LumosApolloClient({ uri, credentials: 'include', fetchPolyfill });
